import React from 'react'
import ReactGA from 'react-ga'
import ym from 'react-yandex-metrika'

import collectionImage from '../../assets/images/01.jpg'
import { AboutProject } from '../../components/AboutProject/AboutProject'
import { Articles } from '../../components/Article/Articles/Articles'
import { Content } from '../../components/Article/Content/Content'
import { Container } from '../../components/Container/Container'
import { Footer } from '../../components/Footer/Footer'
import { Header } from '../../components/Header/Header'
import { BackButton } from '../../components/UI/BackButton/BackButton'

export const handleAnalyticsLink = (id: number, name: string) => {
  ReactGA.ga('send', 'event', 'client link', 'article project link', name)
  ReactGA.ga('rbcspec.send', 'event', 'client link', 'click')

  ym('reachGoal', 'client link', {
    'client link': {
      'article project link': {
        [`Статья ${id}`]: name,
      },
    },
  })
}

export const ArticlePage = () => (
  <>
    <Header />
    <Container>
      <BackButton url='/' />
      <AboutProject
        title='Здесь будет заголовок это рыба в четыре строки'
        text='Здесь будет лид, это рыбный текст. Так говорила в июле 1805 года известная Анна Павловна Шерер, фрейлина и приближенная'
        image={String(collectionImage)}
      />
      <Content />
      <Articles />
    </Container>
    <Footer />
  </>
)
